import React from 'react';

const Interests = () => {
    return (
        <>
            <section className="resume-section" id="interests">
                <div className="resume-section-content">
                    <h2 className="mb-5 text-primary">Interests</h2>
                    <p>Apart from being a web developer, I enjoy most of my time being outdoors.  I am an avid biker. During the warmer months here in Leipzig, I enjoy long distance biking walking in the woods, spending some time next to water.</p>
                    <p className="mb-0">When forced indoors, I follow movies and television shows, I love to discover how the things work and try to fix them in case something went wrong, this was my hobby since i was kind .</p>
                </div>
            </section>
            <hr className="m-0" />
        </>
    )
};

export default Interests